/**
 * @param element
 */
const openDropdown = (element) => {
    element.setAttribute('aria-expanded', 'true')
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeDropdown(element)
    })

    document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-dropdown]') && !event.target.closest('[data-dropdown-toggle]')) closeDropdown(element)
    })
}

/**
 * @param element
 */
const closeDropdown = (element) => {
    element.setAttribute('aria-expanded', 'false')
}

const closeAllDropdowns = () => {
    document.querySelectorAll('[data-dropdown-toggle]').forEach(element => closeDropdown(element))
}

document.querySelectorAll('[data-dropdown-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
        event.preventDefault()
        if (toggle.getAttribute('aria-expanded') === 'false') {
            closeAllDropdowns()
            openDropdown(toggle)
            return
        }

        closeDropdown(toggle)
    })
})
